<div class="row mb-3">
    <div class="col-md-1">
        <app-module-audit-add [isEditMode]="isEditMode"
                              [moduleId]="moduleId"
                              (moduleAuditAdded)="onModuleAuditAdded($event)">
        </app-module-audit-add>
    </div>
</div>

<section class="panel">
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Audit Name</th>
                        <th>Audit Type</th>
                        <th>Order</th>`
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let moduleAudit of moduleAudits;index as i">
                        <td>{{i+1}}</td>
                        <td>{{moduleAudit.name}}</td>
                        <td>{{moduleAudit.auditType}}</td>
                        <td>{{moduleAudit.order}}</td>
                        <td class="actions">
                            <a (click)="selectedAuditId=moduleAudit.auditId; confirmation.showMessage()" title="Delete Module" class="mb-1 mt-1 mr-2"><i class="fas fa-trash"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>

<app-confirmation-message #confirmation (confirmationClicked)="deleteModuleAudits()"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this audit?'">
</app-confirmation-message>
